import React from "react";
import { Checkbox, Collapse, Divider, Modal } from "antd";
import { observer } from "mobx-react-lite";
import { useMst } from "../../store/root";
import styles from "./Modal.module.scss";
import {
  continueRender,
  IFileSizes,
  testBeforeRender,
} from "../../jsxProviders";
import { MainButton, TextButton } from "../baseComponents";
import { analyticsInstance } from "../../analytics/analyticsCtrls";
import { InfoText } from "../InfoText/InfoText";
import { WarningIcon } from "../baseComponents/Icons";
import { fileFormat } from "../../store/utils/utilMethods";
import { ModalTopBar } from "./ModalTopBar";
const maxFileNameLength = 25;
const { Panel } = Collapse;

type FileSizePerType = {
  image: { files: IFileSizes[]; totalSize: number };
  audio: { files: IFileSizes[]; totalSize: number };
  other: { files: IFileSizes[]; totalSize: number };
};
export const FileSizeTooBig = observer(() => {
  const {
    uiStore: {
      fileSizeErrorData,
      setSizeProblemDataModalHidden,
      sizeProblemDataModalVisible,
    },
    compositionStore: {
      setRenderedCompositions,
      compositionCurrentlyRendering,
    },
    renderStore: { setDoNotAskFileSize, doNotAskFileSize },
  } = useMst();
  const [acceptCondition, setAcceptCondition] = React.useState(false);
  const fileSizeAllData = fileSizeErrorData as {
    totalFilesSize: number;
    fileSizes: IFileSizes[];
  };
  const fileSizePerType: FileSizePerType = {
    image: { files: [], totalSize: 0 },
    audio: { files: [], totalSize: 0 },
    other: { files: [], totalSize: 0 },
  };
  fileSizeAllData.fileSizes?.forEach((f) => {
    const fileType = fileFormat(f);
    if (fileType !== "video") {
      fileSizePerType[fileType].files.push(f);
      fileSizePerType[fileType].totalSize += f.sizeInKb;
    }
  });
  console.log(fileSizePerType, "fileSizePerType");
  const handleContinue = () => {
    continueRender();
    setSizeProblemDataModalHidden();
  };

  const cancelRender = () => {
    setRenderedCompositions(compositionCurrentlyRendering.id, false);
    analyticsInstance.sendAnalytics("render", { val: "cancel", sceneName: compositionCurrentlyRendering.name });
    setSizeProblemDataModalHidden();
    testBeforeRender();
  };

  // const dataSource: { [key: string]: number | string }[] =
  //   fileSizeAllData.fileSizes?.map((f, i) => ({
  //     key: i,
  //     fileName: f.name,
  //     fileSize: f.sizeInKb.toFixed(),
  //   }));
  // const columns = [
  //   { title: "File name", dataIndex: "fileName", key: "fileName" },
  //   { title: "File Size (kb)", dataIndex: "fileSize", key: "fileSize" },
  // ];

  const formatSize = (size: number) => {
    return size < 1000
      ? `${size.toFixed(0)} Kb`
      : `${(size / 1000).toFixed(2)} Mb`;
  };

  return (
    <Modal
      className={[styles.Modal, styles.FileSize, styles.NewProjectModal].join(
        " "
      )}
      visible={sizeProblemDataModalVisible}
      onOk={handleContinue}
      onCancel={cancelRender}
      footer={false}
    >
      <ModalTopBar icon={<div style={{color:'#FABB36'}}><WarningIcon/></div>}/>
      <p className={styles.Extra}>Looks like you have some heavy files</p>
      <p className={styles.Subtitle} style={{ fontWeight: "bold" }}>
        Your total file size is {fileSizeAllData.totalFilesSize?.toFixed(2)} Mb.
      </p>
      <div className={styles.Info}>
        <Collapse bordered={false} ghost>
          {fileSizeAllData.fileSizes &&
            Object.entries(fileSizePerType)
              .filter(([type, data]) => data.totalSize !== 0)
              .map(([type, data]) => (
                <>
                  <Panel
                    header={`${type.charAt(0).toUpperCase() + type.slice(1)}s (${formatSize(data.totalSize)})`}
                    key={type}
                  >
                    {data.files.map(({ name, sizeInKb }) => (
                      <div className={styles.Information}>
                        <p title={name} className={styles.Left}>{name}</p>
                        <p className={styles.Right}>
                          {formatSize(sizeInKb)}
                        </p>
                      </div>
                    ))}
                  </Panel>
                </>
              ))}
        </Collapse>
      </div>
      <div style={{ marginTop: "1rem", marginLeft: "4px" }}>
        <InfoText>
          If you exceed a total size of 5 Mb, you may experience a delay in
          loading time.
        </InfoText>
      </div>
      <div className={styles.Checks}>
        <Checkbox
          checked={acceptCondition}
          onChange={(e) => setAcceptCondition(e.target.checked)}
        >
          I understand that rendering heavy files may affect the performance of
          my video
        </Checkbox>
        <Checkbox
          checked={doNotAskFileSize}
          onChange={(e) => setDoNotAskFileSize(e.target.checked)}
        >
          Don’t ask again for this render
        </Checkbox>
      </div>
      <div className={[styles.Buttons, styles.MarginTop].join(" ")}>
        <TextButton onClick={cancelRender} text="cancel" />
        <MainButton
          disabled={!acceptCondition}
          onClick={handleContinue}
          text="Continue"
        />
      </div>
    </Modal>
  );
});
